import React, { Component } from 'react';
import PropTypes from 'prop-types';
// Redux
import { connect } from 'react-redux';

// Google Places Suggest Component
//import GoogleMapLoader from "react-google-maps-loader";
import ReactGoogleMapLoader from "react-google-maps-loader";

import Geosuggest from '@ubilabs/react-geosuggest';

import withStyles from 'isomorphic-style-loader/lib/withStyles';

// Redux  Action
import { setPersonalizedValues } from '../../../actions/personalized';
// Constants
import { googleMapAPI } from '../../../config';

import s from '!isomorphic-style-loader/!css-loader!@ubilabs/react-geosuggest/module/geosuggest.css';

class PlaceGeoSuggest extends Component {

    static propTypes = {
        label: PropTypes.string,
        className: PropTypes.string,
        containerClassName: PropTypes.string,
        setPersonalizedValues: PropTypes.any,
        googleMaps: PropTypes.object,
        personalized: PropTypes.shape({
            location: PropTypes.string,
            lat: PropTypes.number,
            lng: PropTypes.number,
            geography: PropTypes.string
        })
    };

    static defaultProps = {
        personalized: {
            location: null
        }
    }

    constructor(props) {
        super(props);
        this.onSuggestSelect = this.onSuggestSelect.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    onSuggestSelect(data) {
        const { setPersonalizedValues } = this.props;
        let locationData = {};
        if (data && data.gmaps) {
            data.gmaps.address_components.map((item, key) => {
                if (item.types[0] == "administrative_area_level_1") {
                    locationData["administrative_area_level_1_short"] = item.short_name;
                    locationData["administrative_area_level_1_long"] = item.long_name;
                } else if (item.types[0] == "country") {
                    locationData[item.types[0]] = item.short_name;
                } else {
                    locationData[item.types[0]] = item.long_name;
                }
            });
            setPersonalizedValues({ name: 'geography', value: JSON.stringify(locationData) });
            setPersonalizedValues({ name: 'location', value: data.label });
            setPersonalizedValues({ name: 'lat', value: data.location.lat });
            setPersonalizedValues({ name: 'lng', value: data.location.lng });
            setPersonalizedValues({ name: 'chosen', value: 1 });
        }
    }

    onChange(value) {
        const { setPersonalizedValues } = this.props;
        if (value == '') {
            setPersonalizedValues({ name: 'location', value: null });
            setPersonalizedValues({ name: 'chosen', value: null });
            setPersonalizedValues({ name: 'geography', value: null });
        }
    }

    render() {
        const { label, className, containerClassName, personalized, loadField } = this.props;
        return (
            <div>
                <ReactGoogleMapLoader
                    params={{
                        key: googleMapAPI, // Define your api key here
                        libraries: "places", // To request multiple libraries, separate them with a comma
                    }}
                    render={googleMaps => {
                        if (googleMaps) {
                            return (
                                <Geosuggest
                                    ref={el => this._geoSuggest = el}
                                    placeholder={label}
                                    inputClassName={className}
                                    className={containerClassName}
                                    initialValue={personalized.location}
                                    onChange={this.onChange}
                                    onSuggestSelect={this.onSuggestSelect}
                                    autoComplete='off'
                                />
                            )
                        } else if (loadField) {
                            return loadField && loadField();
                        } else {
                            return null
                        }
                        // return loadField()
                    }
                    }
                />
            </div>
        )
    }
}

const mapState = (state) => ({
    personalized: state.personalized
});

const mapDispatch = {
    setPersonalizedValues
};

// export default GoogleMapLoader(withStyles(s)(connect(mapState, mapDispatch)(PlaceGeoSuggest)), {
//   libraries: ["places"],
//   region: "US",
//   language: "en",
//   key: googleMapAPI,
// });

export default withStyles(s)(connect(mapState, mapDispatch)(PlaceGeoSuggest));